<div class="message-container">
  <div class="summary" (click.stop)="collapsible.toggle()" role="button">
    <div class="left">
      {{ 'notifications.maintenance.summary' | portalTranslate }}
    </div>

    <div class="right">
      <span>
        {{
          'notifications.maintenance.latestPublicationDate'
            | portalTranslate: { date: latestPublicationDate() | portalTimeAgo }
        }}
      </span>
      <i class="far fa-angle-down ms-2"></i>
    </div>
  </div>

  <div
    class="backdrop collapsible"
    #collapsible="ngbCollapse"
    [(ngbCollapse)]="isCollapsed"
    (click)="onBackdropClicked($event)"
  >
    <ul class="messages">
      @for (notification of maintenance(); track notification) {
        <li class="message" [class.important]="notification.important">
          <i class="far fa-exclamation-circle icon"></i>

          <div class="content">
            <strong>{{ notification.title }}</strong>
            <small class="description">
              <span>
                {{
                  'notifications.maintenance.updatedAt'
                    | translate: { date: notification.updatedAt | portalTimeAgo }
                }}
              </span>

              @if (notification.beginAt) {
                <span>
                  {{
                    'notifications.maintenance.beginAt'
                      | translate: { date: notification.beginAt | portalDate: 'date-time-no-seconds' }
                  }}
                </span>
              }

              @if (notification.endAt) {
                <span>
                  {{
                    'notifications.maintenance.endAt'
                      | translate: { date: notification.endAt | portalDate: 'date-time-no-seconds' }
                  }}
                </span>
              }
            </small>
          </div>

          <div class="actions">
            <button class="btn btn-secondary" [disabled]="state.busy()" (click)="open(notification)">
              {{ 'common.details' | translate }}
            </button>

            @if (notification.important === false) {
              <portal-icon-button
                [disabled]="state.busy()"
                [loading]="state.busyWith() === `mark-as-seen:${notification.id}`"
                (onClick)="markAsSeen(notification.id)"
                iconClass="far fa-times"
              />
            }
          </div>
        </li>
      }
    </ul>
  </div>
</div>
